import { useEffect, useState } from "react";
import { getInventoryCategories } from "../../api/inventoryService";

export const useInventoryCategories = (trigger, emptyCallback) => {
  // Always start with an empty array, not {}
  const [inventoryCategories, setInventoryCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true); // reset loading when trigger changes
    getInventoryCategories()
      .then((categories) => {
        // Normalize: ensure categories.data is always an array
        setInventoryCategories(Array.isArray(categories.data) ? categories.data : []);
        if (emptyCallback && categories.data.length === 0) emptyCallback(true);
      })
      .catch((error) => {
        console.error("Failed to fetch inventory categories:", error);
        setInventoryCategories([]); // fallback to empty array
      })
      .finally(() => {
        setLoading(false);
      });
  }, [trigger]);

  // Derived state: isEmpty
//   const isEmpty = inventoryCategories.length === 0;

  return { inventoryCategories, loading, setInventoryCategories };
};